import type { CrewIdParam, SimpleResponse } from "src/shared/api-types/common";
import type {
  CreateLimitationDefinitionBody,
  LimitationConfig,
  LimitationDefinition,
  LimitationDefinitionsResponse,
  LimitationIdParam,
  LimitationUsageResponse,
  UpdateLimitationConfigBody,
  UpdateLimitationDefinitionBody,
} from "src/shared/api-types/limitations";

import { typedRequest } from "./typedRequest";

export const getLimitations = async (params: CrewIdParam): Promise<LimitationDefinitionsResponse> => {
  return typedRequest.get({ url: "/limitations/crew/:crewId", params });
};

export const getLimitationConfig = async (params: CrewIdParam): Promise<LimitationConfig> => {
  return typedRequest.get({ url: "/limitations/crew/:crewId/config", params });
};

export const getLimitationUsage = async (params: LimitationIdParam): Promise<LimitationUsageResponse> => {
  return typedRequest.get({ url: "/limitations/crew/:crewId/:limitationId/usage", params });
};

export const updateLimitationConfig = async (
  params: CrewIdParam,
  body: UpdateLimitationConfigBody,
): Promise<LimitationConfig> => {
  return typedRequest.put({ url: "/limitations/crew/:crewId/config", params, body });
};

export const createLimitation = async (
  params: CrewIdParam,
  body: CreateLimitationDefinitionBody,
): Promise<LimitationDefinition> => {
  return typedRequest.post({ url: "/limitations/crew/:crewId", params, body });
};

export const updateLimitation = async (
  params: LimitationIdParam,
  body: UpdateLimitationDefinitionBody,
): Promise<LimitationDefinition> => {
  return typedRequest.put({ url: "/limitations/crew/:crewId/:limitationId", params, body });
};

export const archiveLimitation = async (params: LimitationIdParam): Promise<SimpleResponse> => {
  return typedRequest.delete({ url: "/limitations/crew/:crewId/:limitationId", params });
};

export const restoreLimitation = async (params: LimitationIdParam): Promise<SimpleResponse> => {
  return typedRequest.put({ url: "/limitations/crew/:crewId/:limitationId/restore", params, body: {} });
};
